
// 1) Your “show once” section (paste your exact HTML here)
const SEARCH_ONCE_SECTION_HTML = `
<section id="collection_section" class="shopify-section offer-section section-in-view in_search_hide"><div class="offer-section-wrapper">
  <div class="container">
    <div class="section-heading center-heading"></div>
    <div class="yv-offers-outer">
      <div class="row">
        
<div id="yv-image-gallery-item-image_NbptB6" class="yv-offer-item-main col-10 col-sm-6 col-md-2 aos-init aos-animate" data-aos="fade-up" data-aos-delay="50">
            <div class="yv-offer-item-box content-border-false">
              <a href="/products/certificat-cadeau" class="yv-offer-item " style="height:auto;border-radius:10px;display:flex;flex-direction:column;" aria-label="Carte Cadeau" style="
    height: auto;
    border-radius: 10px;
">
                
                  
<img class="no-js-hidden lazyautosizes lazyloaded" data-aspectratio="0.9642857142857143" data-sizes="auto" data-widths="[375]" width="270" height="280" data-original="//staysharpmtl.com/cdn/shop/files/Rectangle_4_1520fbee-dd74-452f-adc6-8cceeca42328.svg?v=1766561565" alt="" loading="lazy" style="object-position:50.0% 50.0%" data-srcset="//staysharpmtl.com/cdn/shop/files/Rectangle_4_1520fbee-dd74-452f-adc6-8cceeca42328.svg?v=1766561565&amp;width=375 375w" sizes="342px" srcset="//staysharpmtl.com/cdn/shop/files/Rectangle_4_1520fbee-dd74-452f-adc6-8cceeca42328.svg?v=1766561565&amp;width=375 375w">  
<noscript>
    <img     
     src="//staysharpmtl.com/cdn/shop/files/Rectangle_4_1520fbee-dd74-452f-adc6-8cceeca42328.svg?v=1766561565&width=270"
     loading="eager"
      alt="Stay Sharp"
      width="270"
      height="280"
    >
  </noscript>

                
<div class="yv-offer-detail real_bottom-left content-border-true " style="width:100%;    background: #175E54;"><h5 class="gallery-image-heading text-medium">Carte Cadeau</h5></div></a>
            </div>
          </div>
          
        <div id="yv-image-gallery-item-image_VXG84n" class="yv-offer-item-main col-10 col-sm-6 col-md-2 aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
            <div class="yv-offer-item-box content-border-false">
              <a href="/collections/gyuto" class="yv-offer-item " style="height:auto;border-radius:10px;display:flex;flex-direction:column;" aria-label="Gyuto">
                
                  
<img class="no-js-hidden lazyautosizes ls-is-cached lazyloaded" data-aspectratio="0.9642857142857143" data-sizes="auto" data-widths="[375]" width="270" height="280" data-original="//staysharpmtl.com/cdn/shop/files/Rectangle_4_d8c2c3c5-fbd6-49a8-b63c-5203b78dd78f.png?v=1766050664" alt="" loading="lazy" style="object-position:50.0% 50.0%" data-srcset="//staysharpmtl.com/cdn/shop/files/Rectangle_4_d8c2c3c5-fbd6-49a8-b63c-5203b78dd78f.png?v=1766050664&amp;width=375 375w" sizes="342px" srcset="//staysharpmtl.com/cdn/shop/files/Rectangle_4_d8c2c3c5-fbd6-49a8-b63c-5203b78dd78f.png?v=1766050664&amp;width=375 375w">
  
  <noscript>
    <img     
     src="//staysharpmtl.com/cdn/shop/files/Rectangle_4_d8c2c3c5-fbd6-49a8-b63c-5203b78dd78f.png?v=1766050664&width=270"
     loading="eager"
      alt="Stay Sharp"
      width="270"
      height="280"
    >
  </noscript>

                
<div class="yv-offer-detail real_bottom-left content-border-true " style="width:100%;    background: #175E54;"><h5 class="gallery-image-heading text-medium">Gyuto</h5></div></a>
            </div>
          </div>
          
        <div id="yv-image-gallery-item-image_eKEJ9Y" class="yv-offer-item-main col-10 col-sm-6 col-md-2 aos-init aos-animate" data-aos="fade-up" data-aos-delay="150">
            <div class="yv-offer-item-box content-border-false">
              <a href="/collections/santoku" class="yv-offer-item " style="height:auto;border-radius:10px;display:flex;flex-direction:column;" aria-label="Santoku">
                
                  
<img class="no-js-hidden lazyautosizes lazyloaded" data-aspectratio="0.9642857142857143" data-sizes="auto" data-widths="[375]" width="270" height="280" data-original="//staysharpmtl.com/cdn/shop/files/Rectangle_4_1_be9a62f8-799b-4e78-8d63-aef590bb9b7b.png?v=1766055088" alt="" loading="lazy" style="object-position:50.0% 50.0%" data-srcset="//staysharpmtl.com/cdn/shop/files/Rectangle_4_1_be9a62f8-799b-4e78-8d63-aef590bb9b7b.png?v=1766055088&amp;width=375 375w" sizes="342px" srcset="//staysharpmtl.com/cdn/shop/files/Rectangle_4_1_be9a62f8-799b-4e78-8d63-aef590bb9b7b.png?v=1766055088&amp;width=375 375w">
  
  <noscript>
    <img     
     src="//staysharpmtl.com/cdn/shop/files/Rectangle_4_1_be9a62f8-799b-4e78-8d63-aef590bb9b7b.png?v=1766055088&width=270"
     loading="eager"
      alt="Stay Sharp"
      width="270"
      height="280"
    >
  </noscript>

                
<div class="yv-offer-detail real_bottom-left content-border-true " style="width:100%;    background: #175E54;"><h5 class="gallery-image-heading text-medium">Santoku</h5></div></a>
            </div>
          </div>
          
        <div id="yv-image-gallery-item-image_gG3QRn" class="yv-offer-item-main col-10 col-sm-6 col-md-2 aos-init aos-animate" data-aos="fade-up" data-aos-delay="200">
            <div class="yv-offer-item-box content-border-false">
              <a href="/collections/petty" class="yv-offer-item " style="height:auto;border-radius:10px;display:flex;flex-direction:column;" aria-label="Petty">
                
                  
<img class="no-js-hidden lazyautosizes lazyloaded" data-aspectratio="0.9642857142857143" data-sizes="auto" data-widths="[375]" width="270" height="280" data-original="//staysharpmtl.com/cdn/shop/files/Rectangle_4_2_dee8768f-930c-4370-96e7-c6cc15c2afa7.png?v=1766055108" alt="" loading="lazy" style="object-position:50.0% 50.0%" data-srcset="//staysharpmtl.com/cdn/shop/files/Rectangle_4_2_dee8768f-930c-4370-96e7-c6cc15c2afa7.png?v=1766055108&amp;width=375 375w" sizes="342px" srcset="//staysharpmtl.com/cdn/shop/files/Rectangle_4_2_dee8768f-930c-4370-96e7-c6cc15c2afa7.png?v=1766055108&amp;width=375 375w">
  
  <noscript>
    <img     
     src="//staysharpmtl.com/cdn/shop/files/Rectangle_4_2_dee8768f-930c-4370-96e7-c6cc15c2afa7.png?v=1766055108&width=270"
     loading="eager"
      alt="Stay Sharp"
      width="270"
      height="280"
    >
  </noscript>

                
<div class="yv-offer-detail real_bottom-left content-border-true " style="width:100%;    background: #175E54;"><h5 class="gallery-image-heading text-medium">Petty</h5></div></a>
            </div>
          </div>
          
        <div id="yv-image-gallery-item-image_UzE4bQ" class="yv-offer-item-main col-10 col-sm-6 col-md-2 aos-init aos-animate" data-aos="fade-up" data-aos-delay="250">
            <div class="yv-offer-item-box content-border-false">
              <a href="/collections/couteaux-bunka" class="yv-offer-item " style="height:auto;border-radius:10px;display:flex;flex-direction:column;" aria-label="Bunka">
                
                  
<img class="no-js-hidden lazyautosizes lazyloaded" data-aspectratio="0.9642857142857143" data-sizes="auto" data-widths="[375]" width="270" height="280" data-original="//staysharpmtl.com/cdn/shop/files/Rectangle_4_3_6674fdfe-7b01-4a0e-814c-86b47fdd14b5.png?v=1766055123" alt="" loading="lazy" style="object-position:50.0% 50.0%" data-srcset="//staysharpmtl.com/cdn/shop/files/Rectangle_4_3_6674fdfe-7b01-4a0e-814c-86b47fdd14b5.png?v=1766055123&amp;width=375 375w" sizes="342px" srcset="//staysharpmtl.com/cdn/shop/files/Rectangle_4_3_6674fdfe-7b01-4a0e-814c-86b47fdd14b5.png?v=1766055123&amp;width=375 375w">
  
  <noscript>
    <img     
     src="//staysharpmtl.com/cdn/shop/files/Rectangle_4_3_6674fdfe-7b01-4a0e-814c-86b47fdd14b5.png?v=1766055123&width=270"
     loading="eager"
      alt="Stay Sharp"
      width="270"
      height="280"
    >
  </noscript>

                
<div class="yv-offer-detail real_bottom-left content-border-true " style="width:100%;    background: #175E54;"><h5 class="gallery-image-heading text-medium">Bunka</h5></div></a>
            </div>
          </div>
          
        <div id="yv-image-gallery-item-image_xDWR3i" class="yv-offer-item-main col-10 col-sm-6 col-md-2 aos-init aos-animate" data-aos="fade-up" data-aos-delay="300">
            <div class="yv-offer-item-box content-border-false">
              <a href="/collections/deba" class="yv-offer-item " style="height:auto;border-radius:10px;display:flex;flex-direction:column;" aria-label="Deba">
                
                  
<img class="no-js-hidden lazyautosizes lazyloaded" data-aspectratio="0.9642857142857143" data-sizes="auto" data-widths="[375]" width="270" height="280" data-original="//staysharpmtl.com/cdn/shop/files/Rectangle_4_4_c86d2c4d-7a74-4bf9-93c7-624d02fa430a.png?v=1766055143" alt="" loading="lazy" style="object-position:50.0% 50.0%" data-srcset="//staysharpmtl.com/cdn/shop/files/Rectangle_4_4_c86d2c4d-7a74-4bf9-93c7-624d02fa430a.png?v=1766055143&amp;width=375 375w" sizes="342px" srcset="//staysharpmtl.com/cdn/shop/files/Rectangle_4_4_c86d2c4d-7a74-4bf9-93c7-624d02fa430a.png?v=1766055143&amp;width=375 375w">
  
  <noscript>
    <img     
     src="//staysharpmtl.com/cdn/shop/files/Rectangle_4_4_c86d2c4d-7a74-4bf9-93c7-624d02fa430a.png?v=1766055143&width=270"
     loading="eager"
      alt="Stay Sharp"
      width="270"
      height="280"
    >
  </noscript>

                
<div class="yv-offer-detail real_bottom-left content-border-true " style="width:100%;    background: #175E54;"><h5 class="gallery-image-heading text-medium">Deba</h5></div></a>
            </div>
          </div>
          
        <div id="yv-image-gallery-item-image_KnUKQp" class="yv-offer-item-main col-10 col-sm-6 col-md-2 aos-init aos-animate" data-aos="fade-up" data-aos-delay="350">
            <div class="yv-offer-item-box content-border-false">
              <a href="/collections/honesuki" class="yv-offer-item " style="height:auto;border-radius:10px;display:flex;flex-direction:column;" aria-label="Honesuki">
                
                  
<img class="no-js-hidden lazyautosizes lazyloaded" data-aspectratio="0.9642857142857143" data-sizes="auto" data-widths="[375]" width="270" height="280" data-original="//staysharpmtl.com/cdn/shop/files/Rectangle_4_5_935ee377-c38f-479a-b4f3-4e130e7ca1ab.png?v=1766055160" alt="" loading="lazy" style="object-position:50.0% 50.0%" data-srcset="//staysharpmtl.com/cdn/shop/files/Rectangle_4_5_935ee377-c38f-479a-b4f3-4e130e7ca1ab.png?v=1766055160&amp;width=375 375w" sizes="342px" srcset="//staysharpmtl.com/cdn/shop/files/Rectangle_4_5_935ee377-c38f-479a-b4f3-4e130e7ca1ab.png?v=1766055160&amp;width=375 375w">
  
  <noscript>
    <img     
     src="//staysharpmtl.com/cdn/shop/files/Rectangle_4_5_935ee377-c38f-479a-b4f3-4e130e7ca1ab.png?v=1766055160&width=270"
     loading="eager"
      alt="Stay Sharp"
      width="270"
      height="280"
    >
  </noscript>

                
<div class="yv-offer-detail real_bottom-left content-border-true " style="width:100%;    background: #175E54;"><h5 class="gallery-image-heading text-medium">Honesuki</h5></div></a>
            </div>
          </div>
          
        <div id="yv-image-gallery-item-image_HnghgT" class="yv-offer-item-main col-10 col-sm-6 col-md-2 aos-init aos-animate" data-aos="fade-up" data-aos-delay="400">
            <div class="yv-offer-item-box content-border-false">
              <a href="/collections/kiritsuke" class="yv-offer-item " style="height:auto;border-radius:10px;display:flex;flex-direction:column;" aria-label="Kiritsuke">
                
                  
<img class="no-js-hidden lazyautosizes lazyloaded" data-aspectratio="0.9642857142857143" data-sizes="auto" data-widths="[375]" width="270" height="280" data-original="//staysharpmtl.com/cdn/shop/files/Rectangle_4_6_a5e4decb-728e-4d5c-9345-ddd4a1e767ac.png?v=1766055177" alt="" loading="lazy" style="object-position:50.0% 50.0%" data-srcset="//staysharpmtl.com/cdn/shop/files/Rectangle_4_6_a5e4decb-728e-4d5c-9345-ddd4a1e767ac.png?v=1766055177&amp;width=375 375w" sizes="342px" srcset="//staysharpmtl.com/cdn/shop/files/Rectangle_4_6_a5e4decb-728e-4d5c-9345-ddd4a1e767ac.png?v=1766055177&amp;width=375 375w">
  
  <noscript>
    <img     
     src="//staysharpmtl.com/cdn/shop/files/Rectangle_4_6_a5e4decb-728e-4d5c-9345-ddd4a1e767ac.png?v=1766055177&width=270"
     loading="eager"
      alt="Stay Sharp"
      width="270"
      height="280"
    >
  </noscript>

                
<div class="yv-offer-detail real_bottom-left content-border-true " style="width:100%;    background: #175E54;"><h5 class="gallery-image-heading text-medium">Kiritsuke</h5></div></a>
            </div>
          </div>
          
        <div id="yv-image-gallery-item-image_GUXy6R" class="yv-offer-item-main col-10 col-sm-6 col-md-2 aos-init aos-animate" data-aos="fade-up" data-aos-delay="450">
            <div class="yv-offer-item-box content-border-false">
              <a href="/collections/nakiri" class="yv-offer-item " style="height:auto;border-radius:10px;display:flex;flex-direction:column;" aria-label="Nakiri">
                
                  
<img class="no-js-hidden lazyautosizes lazyloaded" data-aspectratio="0.9642857142857143" data-sizes="auto" data-widths="[375]" width="270" height="280" data-original="//staysharpmtl.com/cdn/shop/files/Rectangle_4_7_43228c0f-0d60-4e99-9121-74ba2cb37d41.png?v=1766055193" alt="" loading="lazy" style="object-position:50.0% 50.0%" data-srcset="//staysharpmtl.com/cdn/shop/files/Rectangle_4_7_43228c0f-0d60-4e99-9121-74ba2cb37d41.png?v=1766055193&amp;width=375 375w" sizes="342px" srcset="//staysharpmtl.com/cdn/shop/files/Rectangle_4_7_43228c0f-0d60-4e99-9121-74ba2cb37d41.png?v=1766055193&amp;width=375 375w">
  
  <noscript>
    <img     
     src="//staysharpmtl.com/cdn/shop/files/Rectangle_4_7_43228c0f-0d60-4e99-9121-74ba2cb37d41.png?v=1766055193&width=270"
     loading="eager"
      alt="Stay Sharp"
      width="270"
      height="280"
    >
  </noscript>

                
<div class="yv-offer-detail real_bottom-left content-border-true " style="width:100%;    background: #175E54;"><h5 class="gallery-image-heading text-medium">Nakiri</h5></div></a>
            </div>
          </div>
          
        <div id="yv-image-gallery-item-image_NHWqXV" class="yv-offer-item-main col-10 col-sm-6 col-md-2 aos-init aos-animate" data-aos="fade-up" data-aos-delay="500">
            <div class="yv-offer-item-box content-border-false">
              <a href="/products/certificat-cadeau" class="yv-offer-item " style="height:auto;border-radius:10px;display:flex;flex-direction:column;" aria-label="Carte Cadeau">
                
                  
<img class="no-js-hidden lazyautosizes lazyloaded" data-aspectratio="0.9642857142857143" data-sizes="auto" data-widths="[375]" width="270" height="280" data-original="//staysharpmtl.com/cdn/shop/files/Rectangle_4_d8c2c3c5-fbd6-49a8-b63c-5203b78dd78f.png?v=1766050664" alt="" loading="lazy" style="object-position:50.0% 50.0%" data-srcset="//staysharpmtl.com/cdn/shop/files/Rectangle_4_d8c2c3c5-fbd6-49a8-b63c-5203b78dd78f.png?v=1766050664&amp;width=375 375w" sizes="342px" srcset="//staysharpmtl.com/cdn/shop/files/Rectangle_4_d8c2c3c5-fbd6-49a8-b63c-5203b78dd78f.png?v=1766050664&amp;width=375 375w">
  
  <noscript>
    <img     
     src="//staysharpmtl.com/cdn/shop/files/Rectangle_4_d8c2c3c5-fbd6-49a8-b63c-5203b78dd78f.png?v=1766050664&width=270"
     loading="eager"
      alt="Stay Sharp"
      width="270"
      height="280"
    >
  </noscript>

                
<div class="yv-offer-detail real_bottom-left content-border-true " style="width:100%;    background: #175E54;"><h5 class="gallery-image-heading text-medium">Carte Cadeau</h5></div></a>
            </div>
          </div>
          
        <div id="yv-image-gallery-item-image_Fam7TH" class="yv-offer-item-main col-10 col-sm-6 col-md-2 aos-init aos-animate" data-aos="fade-up" data-aos-delay="550">
            <div class="yv-offer-item-box content-border-false">
              <a href="/collections/yanagiba" class="yv-offer-item " style="height:auto;border-radius:10px;display:flex;flex-direction:column;" aria-label="Yanagiba">
                
                  
<img class="no-js-hidden lazyautosizes lazyloaded" data-aspectratio="0.9642857142857143" data-sizes="auto" data-widths="[375]" width="270" height="280" data-original="//staysharpmtl.com/cdn/shop/files/Rectangle_4_8_98e27d98-9003-43b8-a9d1-3f7d759d989b.png?v=1766055272" alt="" loading="lazy" style="object-position:50.0% 50.0%" data-srcset="//staysharpmtl.com/cdn/shop/files/Rectangle_4_8_98e27d98-9003-43b8-a9d1-3f7d759d989b.png?v=1766055272&amp;width=375 375w" sizes="342px" srcset="//staysharpmtl.com/cdn/shop/files/Rectangle_4_8_98e27d98-9003-43b8-a9d1-3f7d759d989b.png?v=1766055272&amp;width=375 375w">
  
  <noscript>
    <img     
     src="//staysharpmtl.com/cdn/shop/files/Rectangle_4_8_98e27d98-9003-43b8-a9d1-3f7d759d989b.png?v=1766055272&width=270"
     loading="eager"
      alt="Stay Sharp"
      width="270"
      height="280"
    >
  </noscript>

                
<div class="yv-offer-detail real_bottom-left content-border-true " style="width:100%;    background: #175E54;"><h5 class="gallery-image-heading text-medium">Yanagiba</h5></div></a>
            </div>
          </div>
          
        <div id="yv-image-gallery-item-image_zxHUUm" class="yv-offer-item-main col-10 col-sm-6 col-md-2 aos-init aos-animate" data-aos="fade-up" data-aos-delay="600">
            <div class="yv-offer-item-box content-border-false">
              <a href="/collections/couperet" class="yv-offer-item " style="height:auto;border-radius:10px;display:flex;flex-direction:column;" aria-label="Couperets">
                
                  
<img class="no-js-hidden lazyautosizes lazyloaded" data-aspectratio="0.9642857142857143" data-sizes="auto" data-widths="[375]" width="270" height="280" data-original="//staysharpmtl.com/cdn/shop/files/Rectangle_4_9_4599fa70-020f-4aa4-a7c0-52b95ca5a48f.png?v=1766055288" alt="" loading="lazy" style="object-position:50.0% 50.0%" data-srcset="//staysharpmtl.com/cdn/shop/files/Rectangle_4_9_4599fa70-020f-4aa4-a7c0-52b95ca5a48f.png?v=1766055288&amp;width=375 375w" sizes="342px" srcset="//staysharpmtl.com/cdn/shop/files/Rectangle_4_9_4599fa70-020f-4aa4-a7c0-52b95ca5a48f.png?v=1766055288&amp;width=375 375w">
  
  <noscript>
    <img     
     src="//staysharpmtl.com/cdn/shop/files/Rectangle_4_9_4599fa70-020f-4aa4-a7c0-52b95ca5a48f.png?v=1766055288&width=270"
     loading="eager"
      alt="Stay Sharp"
      width="270"
      height="280"
    >
  </noscript>

                
<div class="yv-offer-detail real_bottom-left content-border-true " style="width:100%;    background: #175E54;"><h5 class="gallery-image-heading text-medium">Couperets</h5></div></a>
            </div>
          </div>
          
        
      </div>
    </div>
  </div>
</div>
<style>
  #collection_section.shopify-section{
    
    
    background:var(--primaryColorBody);
    padding-top:45px;
    padding-bottom:45px;--columnGap: 10px;
  }#yv-image-gallery-item-image_NbptB6 .gallery-image-heading {
      color:#ffffff;
    }
    #yv-image-gallery-item-image_NbptB6 .gallery-image-subheading {
      color:#ffffff;
    }#yv-image-gallery-item-image_VXG84n .gallery-image-heading {
      color:#ffffff;
    }
    #yv-image-gallery-item-image_VXG84n .gallery-image-subheading {
      color:#ffffff;
    }#yv-image-gallery-item-image_eKEJ9Y .gallery-image-heading {
      color:#ffffff;
    }
    #yv-image-gallery-item-image_eKEJ9Y .gallery-image-subheading {
      color:#ffffff;
    }#yv-image-gallery-item-image_gG3QRn .gallery-image-heading {
      color:#ffffff;
    }
    #yv-image-gallery-item-image_gG3QRn .gallery-image-subheading {
      color:#ffffff;
    }#yv-image-gallery-item-image_UzE4bQ .gallery-image-heading {
      color:#ffffff;
    }
    #yv-image-gallery-item-image_UzE4bQ .gallery-image-subheading {
      color:#ffffff;
    }#yv-image-gallery-item-image_xDWR3i .gallery-image-heading {
      color:#ffffff;
    }
    #yv-image-gallery-item-image_xDWR3i .gallery-image-subheading {
      color:#ffffff;
    }#yv-image-gallery-item-image_KnUKQp .gallery-image-heading {
      color:#ffffff;
    }
    #yv-image-gallery-item-image_KnUKQp .gallery-image-subheading {
      color:#ffffff;
    }#yv-image-gallery-item-image_HnghgT .gallery-image-heading {
      color:#ffffff;
    }
    #yv-image-gallery-item-image_HnghgT .gallery-image-subheading {
      color:#ffffff;
    }#yv-image-gallery-item-image_GUXy6R .gallery-image-heading {
      color:#ffffff;
    }
    #yv-image-gallery-item-image_GUXy6R .gallery-image-subheading {
      color:#ffffff;
    }#yv-image-gallery-item-image_NHWqXV .gallery-image-heading {
      color:#ffffff;
    }
    #yv-image-gallery-item-image_NHWqXV .gallery-image-subheading {
      color:#ffffff;
    }#yv-image-gallery-item-image_Fam7TH .gallery-image-heading {
      color:#ffffff;
    }
    #yv-image-gallery-item-image_Fam7TH .gallery-image-subheading {
      color:#ffffff;
    }#yv-image-gallery-item-image_zxHUUm .gallery-image-heading {
      color:#ffffff;
    }
    #yv-image-gallery-item-image_zxHUUm .gallery-image-subheading {
      color:#ffffff;
    }@media only screen and (max-width:575px) {
    #collection_section.shopify-section{
      padding-top:35px;
      padding-bottom:0px;
      --columnGap: 10px;
    }
  }
  
</style>

<div style="clear:both"></div></section>
`;
let hasShownSearchOnceSection = false;

function ensureSearchOnceSection() {
  // If already visible this search session, do nothing
  if (hasShownSearchOnceSection) return;

  const existing = document.getElementById("collection_section");
  if (existing) {
    existing.style.display = "";
    hasShownSearchOnceSection = true;
    return;
  }

  const container = document.querySelector(".search-bar-container");
  if (!container) return;

  container.insertAdjacentHTML("beforeend", SEARCH_ONCE_SECTION_HTML);
  hasShownSearchOnceSection = true;
}

function hideSearchOnceSection() {
  const existing = document.getElementById("collection_section");
  if (existing) existing.style.display = "none";

  // ✅ allow showing again when user types again
  hasShownSearchOnceSection = false;
}


document.addEventListener("DOMContentLoaded", searchTabsInit, false);
document.addEventListener("shopify:section:load", searchTabsInit, false);
document.addEventListener("DOMContentLoaded", speechInit, false);
document.addEventListener("shopify:section:load", speechInit, false);
var $resultsBox = $('.yv-search-result-container');
var searchbarresult=$('body').find('.yv-header-searchbar-content');

function removeHtmlEntities(str) {
    const htmlEntities = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&apos;"
    };
    return str.replace(/([&<>\"'])/g, match => htmlEntities[match]);
}

function searchTabsInit() {
    var tabHead = document.getElementsByClassName('yv-tab-result-head');
    if (tabHead.length > 0) {
        var tabContent = document.getElementsByClassName('yv-search-result-list');
        Array.from(tabHead).forEach(function(btn) {
            btn.addEventListener("click", (e) => {
                e.preventDefault();
                Array.from(tabHead).forEach(function(item) {
                item.classList.remove('active');
                });
                let searchUrl = btn.getAttribute("data-resulturl");
                let searchContainer = document.querySelector('.search-bar-container');
                if (searchContainer) {
                    let allresultLink = searchContainer.querySelector('.search-result-bottom');
                    if (searchContainer) {
                        allresultLink.setAttribute('href', searchUrl);
                    }
                }
                Array.from(tabContent).forEach(function(item) {
                    item.classList.remove('active');
                });
                btn.classList.add("active");
                var _value = btn.getAttribute("data-results");
                document.getElementById(_value).classList.add("active");
            });
        });
    }
}

var searchTyping;
$(document).ready(function() {
    $('body').on('click','.search-form',function(e) {
        e.preventDefault();
        focusElement = $('.search-form');
        var _class = $(this).data('search-drawer');
        $('body').toggleClass(_class);
        $('input.search-input').trigger('focus');
        $('#recent_search_list').html('');
        recentSearch();
        focusElementsRotation($('.search-bar-container'));
    });
    /// AjaX Product Search
    $('.AjaxSearchResponse').prepend('');
    $('.search-close').show();
    $('body').on('keydown', '.search-input', function(e) {
        clearTimeout(searchTyping);
       if (this.value.length === 0 && e.which === 32) e.preventDefault();
    });
    $('body').on('keyup', '.search-input', function(e) {
        clearTimeout(searchTyping);
        var _this = $(this);
        searchResults(_this)
    })
    //Search box should mimic live search string: products only, partial match
    $('.search-form, #search-form').on('submit', function(e) {
        e.preventDefault();
        var term = '*' + $(this).find('input[name="q"]').val() + '*';
        var linkURL = $(this).attr('action') + '?q=' + term + '&options%5Bprefix%5D=last';
        window.location = linkURL;
    });

$('body').on('click', '.yv-search-drawer-close', function(e) {
  e.preventDefault();
  $('input.form-control.search-input').val('');
  $resultsBox.empty();
  $('body').removeClass('addsearch');

  hideSearchOnceSection();

  stopFocusElementsRotation();
  focusElement.trigger('focus');
});

  $('body').on('click', '.yv-search-bar', function(e) {
    if($(this).val().length > 2){
        $('.yv-header-searchbar-content').show();
    }
  })

   $(document).on("focus","button[data-searchbar-cross]",function(e) {
     e.preventDefault();
     $(this).hide();
     $(".yv-search-bar").val("");
     searchbarresult.hide();
      searchbarresult.html("");
   })
    // search ends
});


function recentSearch() {
    $('#recent_search_list').html('');
    $('.recent-search-list').siblings('.yv-search-result-container').removeClass('no-recent')
    var recent_Html = '';
    var showRecent = false;
    setTimeout(function() {
        var recent_pro = localStorage.getItem("Recent_search");
        var recent_pro_val = JSON.parse(recent_pro);
        $('.recent-search-list').html('');
        if (recent_pro_val == null) {
            $('.recent-search-list').html('');
            $('.recent-search-list').siblings('.yv-search-result-container').addClass('no-recent');
        } else {
            recent_Html = recent_Html.concat('<h6 class="recent-search-title">' + searchRecentTitleText + '</h6>');
            recent_Html = recent_Html.concat('<ul class="list-unstyled recent-search-listing">');
            var Prev_search = recent_pro_val.reverse();
            $.each(Prev_search, function(index, value) {
                var productUrl = '';
                if (rootUrl.length > 1) {
                    productUrl = rootUrl;
                }
                if (index < 10) {
                    var getV = value;
                    jQuery.ajax({
                        type: 'GET',
                        url: productUrl + '/products/' + value + '.json',
                        success: function(response) {
                            showRecent = true;
                            let product = response.product;
                            let imgSrc = noProductImage;
                            let productTitle = $('<div>' + product.title + '</div>').text();
                            if (product.image) {
                                imgSrc = `<img src="${product.image.src}&width=100" alt="${removeHtmlEntities(productTitle)}">`;
                            }
                            recent_Html += `<li><a class="focus-inside" href="${productUrl}/products/${product.handle}">
                      ${imgSrc}<span>${truncate(removeHtmlEntities(productTitle),2)}</span></a></li>`;
                        },
                        error: function(error) {
                            console.log("Error: " + error);
                        }
                    });
                }
            });
            $(document).ajaxStop(function() {
                recent_Html = recent_Html.concat('</ul>');
                if (showRecent) {
                    $('#recent_search_list').html(recent_Html);
                    focusElementsRotation($('.search-bar-container'));
                }
            });
        }
    }, 500);
}

function searchResults(inputField){
    var section_id='';
    var _drawer = $('[data-search-drawer]').data('search-drawer');
    var _searchContainer = $('body').find('.search-bar-container');
    var retrievedSearch = localStorage.getItem("Recent_search");
    var retrievedSearch_v = JSON.parse(retrievedSearch);   
    if (retrievedSearch_v == null) {
        var retrievedSearch_v = [];
    }
    var $form = inputField.closest('form');
    searchTyping = setTimeout(function() {
        $resultsBox.html(preLoadLoadGif);  
        var term = $form.find('input[name="q"]').val();
        var resultType = 'product';
        if (searchPageResults) {
            resultType += ',page'
        }
        if (searchArticleResults) {
            resultType += ',article'
        }
        if (searchCollectionResults) {
            resultType += ',collection'
        }
        if (searchSuggestions) {
            resultType += ',query'
        }
      if(inputField.hasClass("yv-search-bar")){
        searchbarresult.show();
        searchbarresult.html(preLoadLoadGif);
        section_id='predictive-search-lite';       
      }else{
          section_id='predictive-search';
      }
 // ✅ 1) If cleared (or too short), hide everything and STOP
if (!term || term.trim().length <= 2) {
  $resultsBox.empty();
  searchbarresult.empty();
  $("button[data-searchbar-cross]").hide();
  searchbarresult.css("display", "none");

  hideSearchOnceSection();

  focusElementsRotation($('.search-bar-container'));
  inputField.data('oldval', term); // keep oldval in sync
  return;
}

// ✅ 2) If user is searching, ensure section is visible
ensureSearchOnceSection();

// ✅ 3) Only fetch if the value changed
if (term != inputField.data('oldval')) {

  if (inputField.hasClass("yv-search-bar")) {
    $("button[data-searchbar-cross]").show();
  }

  fetch(searchUrl + "/suggest?section_id=" + section_id + "&q=" + term + "&resources[type]=" + resultType + "&resources[options][fields]=author,tag,title,product_type,variants.title,vendor,variants.sku")
    .then((response) => response.text())
    .then((resultHtml) => {
      let results = new DOMParser()
        .parseFromString(resultHtml, 'text/html')
        .querySelector('#shopify-section-' + section_id);

      if (inputField.hasClass("yv-search-bar")) {
        if (results) {
          searchbarresult.html(results.innerHTML);
        }
      } else {
        if (_searchContainer.find('[data-search-suggestions]').length > 0) {
          if (results && results.querySelector('[data-search-suggestions]')) {
            _searchContainer
              .find('[data-search-suggestions]')
              .html(results.querySelector('[data-search-suggestions]').innerHTML);

            results.querySelector('[data-search-suggestions]').innerHTML = '';
          } else {
            _searchContainer.find('[data-search-suggestions]').html('');
          }
        }

        if (results) {
          $resultsBox.html(results.innerHTML);
          searchTabsInit();

          if (recentProductHandle && retrievedSearch_v.includes(recentProductHandle) === false) {
            retrievedSearch_v.push(recentProductHandle);
          }
          localStorage.setItem("Recent_search", JSON.stringify(retrievedSearch_v));
        } else {
          $resultsBox.empty();
        }

        focusElementsRotation($('.search-bar-container'));
      }
    });

  // ✅ update oldval after fetch trigger
  inputField.data('oldval', term);
}

    }, 1000);
}

function speechInit() {
    let searchBySpeechs = document.querySelectorAll("[data-speech-search]");
    Array.from(searchBySpeechs).forEach(function (searchBySpeech) {
        initSpeectRecognition(searchBySpeech);
    });
}
function initSpeectRecognition(searchSpeech) {
    let speechRecognition = null;
    let listening = false;
    let searchInput = null;
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (
        "webkitSpeechRecognition" in window &&
        userAgent.indexOf("chrome") > -1 &&
        !!window.chrome &&
        userAgent.indexOf("edg/") === -1
    ) {
        searchSpeech.classList.remove("hidden");
        speechRecognition = new window.webkitSpeechRecognition();
        speechRecognition.continuous = false;
        speechRecognition.interimResults = false;
        searchInput = searchSpeech
            .closest("form")
            .querySelector("[data-search-input]");
        speechRecognition.addEventListener(
            "result",
            debounce((evt) => {
                if (evt.results) {
                    const term = evt.results[0][0].transcript;
                    searchInput.value = term;
                    searchInput.focus();
                    searchInput.dispatchEvent(new Event("input"));
                    searchResults($(searchInput))
                }
            }, 300)
        );
        speechRecognition.addEventListener("audiostart", () => {
            listening = true;
            searchSpeech.classList.add("active");
        });
        speechRecognition.addEventListener("audioend", () => {
            listening = false;
            searchSpeech.classList.remove("active");
        });
        searchSpeech.addEventListener("click", function (evt) {
            evt.preventDefault();
            if (listening) {
                speechRecognition.stop();
                listening = false;
            } else {
                speechRecognition.start();
                listening = true;
            }
        });
        searchSpeech.addEventListener("keydown", (evt) => {
            if (evt.code === "Space" || evt.code === "Enter") {
                evt.preventDefault();
                if (listening) {
                    speechRecognition.stop();
                } else {
                    speechRecognition.start();
                }
            }
        });
    }
}

